import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import APIKit from "../../config/APIKit";

export const fetchSubCategoriesFromCategories = createAsyncThunk(
    'subcategories/fetchSubCategoriesFromCategories',
    async (category_id, { rejectWithValue }) => {
      try {
        const response = await APIKit.get(`product/sub/category/list/category/${category_id}`);
        return response.data;
      } catch (error) {
        if (error && typeof error === 'object' && error.response) {
          return rejectWithValue(error.response?.data || 'Sub-categories fetch failed');
        }
        return rejectWithValue('Sub-categories fetch failed');
      }
    }
  );

const subCategoriesSlice = createSlice({
  name: "subCategories",
  initialState: {
    subCategories: null ,
    status: "idle",
    error: null ,
  },
  reducers: {
    clearSubCategories: (state) => {
      state.subCategories = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubCategoriesFromCategories.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSubCategoriesFromCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subCategories = action.payload.data || action.payload;
        state.error = null;
      })
      .addCase(fetchSubCategoriesFromCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Banner get failed";
      });
  },
});

export const { clearSubCategories } = subCategoriesSlice.actions;
export default subCategoriesSlice.reducer;
